export const CET6_CONFUSE = [
  {
    "a": "economic",
    "b": "economical",
    "egs": [
      "The boy left school for economic reasons.",
      "To rent a house is more economical than to buy one."
    ]
  },
  {
    "a": "ensure",
    "b": "insure",
    "egs": [
      "After signing a contract with a professional baseball team",
      "Please ensure (that) all lights are switched off."
    ]
  },
  {
    "a": "electric",
    "b": "electrical",
    "egs": [
      "All the electrical work was done by my younger brother.",
      "He buried himself in an electrical book."
    ]
  },
  {
    "a": "historic",
    "b": "historical",
    "egs": []
  },
  {
    "a": "lie",
    "b": "lay",
    "egs": [
      "He lay under a tree to sleep.",
      "The dog laid its ears back."
    ]
  },
  {
    "a": "considerable",
    "b": "considerate",
    "egs": [
      "He met a considerable amount of trouble.",
      "It was very considerate of you to send me a birthday card."
    ]
  },
  {
    "a": "intense",
    "b": "intensive",
    "egs": []
  },
  {
    "a": "raise",
    "b": "rise",
    "egs": [
      "He raised his voice.",
      "Her wages were raised."
    ]
  },
  {
    "a": "invaluable",
    "b": "valueless",
    "egs": [
      "Your services are invaluable to us．",
      "That book is valueless．"
    ]
  },
  {
    "a": "accident",
    "b": "incident",
    "egs": []
  },
  {
    "a": "affect",
    "b": "effect",
    "egs": [
      "Smoking affects health.",
      "Government policy will not have any effect on us."
    ]
  },
  {
    "a": "continuous",
    "b": "continual",
    "egs": []
  },
  {
    "a": "conserve",
    "b": "preserve",
    "egs": [
      "In winter, some people conserve energy by lowing the heat at night.",
      "The government preserves the rights of the individual person."
    ]
  },
  {
    "a": "sensitive",
    "b": "sensible",
    "egs": []
  },
  {
    "a": "incredible",
    "b": "incredulous",
    "egs": []
  },
  {
    "a": "special",
    "b": "specific",
    "egs": [
      "His specific problems got him into trouble."
    ]
  },
  {
    "a": "complement",
    "b": "compliment",
    "egs": [
      "The team needs players who complement each other.",
      "Please give my compliments to your parents."
    ]
  },
  {
    "a": "stuff",
    "b": "staff",
    "egs": [
      "Put that stuff over there."
    ]
  },
  {
    "a": "conducive",
    "b": "conductive",
    "egs": [
      "Exercise is conducive to health.",
      "We should create an atmosphere conducive to study."
    ]
  },
  {
    "a": "confidant",
    "b": "confident",
    "egs": [
      "He is my confidant.",
      "I am confident of success."
    ]
  },
  {
    "a": "resist",
    "b": "persist",
    "egs": [
      "Lack of proper nourishment reduces their power to resist disease.",
      "On the tops of very high mountains snow persists throughout the year."
    ]
  },
  {
    "a": "technology",
    "b": "technique",
    "egs": []
  },
  {
    "a": "principal",
    "b": "principle",
    "egs": [
      "The principal reason for my decision was the money.",
      "It's the first principle of aerodynamics."
    ]
  },
  {
    "a": "transfer",
    "b": "transmit",
    "egs": [
      "He transferred the package from one hand to the other.",
      "I transferred from Rutgers to Tulane."
    ]
  }
];
